import { TOGGLE_FORM } from '../actions';

const INITIAL_STATE = {
  showForm: true
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_FORM:
      return {...state, showForm: !state.showForm};
    default:
      return state;
  }
}